function normalizeEmailSendUi(result) {
  if (!result || typeof result !== 'object') return null

  var ui = result.ui || result.emailSendUi || null
  if (!ui || typeof ui !== 'object') return null
  if (String(ui.type || '').toLowerCase() !== 'email-send') return null

  var readyCount = normalizeCount(ui.readyCount || result.readyCount)

  return {
    type: 'email-send',
    readyCount: readyCount,
    title: String(ui.title || renderTitle(readyCount)),
    message: String(ui.message || 'Les emails seront envoyés dans les prochaines minutes.'),
    closeLabel: String(ui.closeLabel || ui.close || 'Fermer')
  }
}

function renderEmailSendUi(emailSendUi) {
  return (
    '<div class="wc-email-send-ui">' +
      '<div class="wc-email-send-count">' + escapeHtml(String(emailSendUi.readyCount || 0)) + '</div>' +
      '<div class="wc-email-send-title">' + escapeHtml(emailSendUi.title || renderTitle(emailSendUi.readyCount || 0)) + '</div>' +
      '<div class="wc-email-send-copy">' + escapeHtml(emailSendUi.message || '') + '</div>' +
      '<div class="wc-email-send-actions">' +
        '<button type="button" class="wc-email-send-close" data-email-send-close>' + escapeHtml(emailSendUi.closeLabel || 'Fermer') + '</button>' +
      '</div>' +
    '</div>'
  )
}

function bindEmailSendUi(el, emailSendUi, handlers) {
  if (!el || !emailSendUi) return
  var button = el.querySelector('[data-email-send-close]')
  if (!button) return
  button.addEventListener('click', function () {
    if (handlers && typeof handlers.onClose === 'function') {
      handlers.onClose()
    }
  })
}

function renderTitle(count) {
  return String(count || 0) + ' emails prêts à être envoyés'
}

function normalizeCount(value) {
  var numeric = Number(value)
  return Number.isFinite(numeric) && numeric >= 0 ? Math.floor(numeric) : 0
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export { normalizeEmailSendUi, renderEmailSendUi, bindEmailSendUi }
